(function() {
    const c24 = window.c24;

    c24.lp.appSplash = {

        init: function() {

            if (! $('.c24AppSplash').length) {
                $('body').removeClass('c24Fixed');
                $('body').removeClass('js24AppSplash');
                return;
            }

            c24.lp.appSplash.wpset = '';

            if (window.c24LpWpset) {
                c24.lp.appSplash.wpset = '-' + window.c24LpWpset;
            }

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'appsplash:shown',
                'AppSplash-shown' + c24.lp.appSplash.wpset,
            ]);

            $('.js24OpenAppSplash').show().on('click', function() {
                c24.lp.appSplash.show();

                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'appsplash:shown_coupon',
                    'AppSplash-shown-coupon' + c24.lp.appSplash.wpset,
                ]);
            });

            c24.lp.appSplash.registerEvents();

            if (window.c24LpSetHideAppSplashCookie) {
                c24.lp.appSplash.setHideCookie();
            }
        },

        registerEvents: function() {

            $('.c24AppSplash .c24AppSplashClose').on('click', function(e) {

                e.stopPropagation();

                c24.lp.appSplash.hide();

                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'appsplash:closed',
                    'AppSplash-closed' + c24.lp.appSplash.wpset,
                ]);

                setTimeout(function() {
                    window.c24LpFrameJsReady.then(function() {
                        window.c24LpCssLoaded.then(function() {
                            window.c24LpCheck24.cookieBanner.init(true);
                        });
                    });
                }, 500);
            });

            $('.c24AppSplash .c24Button').on('click', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'appsplash:clicked',
                    'AppSplash-clicked' + c24.lp.appSplash.wpset,
                ]);
            });

            if (window.c24LpIsMobile) {

                const href = $('.c24AppSplash .c24Button').attr('href');

                $('.c24AppSplash').on('click', function() {
                    c24.lp.appSplash.hide();
                    window.location.href = href;
                });
            } else {
                $('.c24AppSplash .box24Background').on('click', function() {
                    c24.lp.appSplash.hide();
                });
            }

            $('.c24AppSplash .box24Disclaimer').on('click', function(e) {
                e.stopPropagation();
            });

            const oAppSms = $('.c24AppSplash .js24Sms') || null;
            if (oAppSms) {
                const sDefaultButtonText = $('button', oAppSms).text();
                $(oAppSms).submit(function(event) {

                    event.preventDefault();

                    const sNumber = $('input[name="number"]', oAppSms).val();
                    if (!sNumber || /^[/+]*[0-9 ]{8,22}$/im.test(sNumber) === false) {
                        return;
                    }

                    const sChallenge = $('input[name="challenge"]', oAppSms).val();

                    const oData = {
                        'number': sNumber,
                        'challenge': sChallenge,
                    };

                    $('input', oAppSms).prop('disabled', true);
                    $('button', oAppSms).prop('disabled', true);
                    $('button', oAppSms).text($('button', oAppSms).data('sending'));

                    const buttonUpdate = function(timeout, message) {
                        if (timeout < 1) {
                            $('input', oAppSms).prop('disabled', false);
                            $('button', oAppSms).prop('disabled', false);
                            $('button', oAppSms).text(sDefaultButtonText);
                        } else {
                            $('input', oAppSms).prop('disabled', true);
                            $('button', oAppSms).prop('disabled', true);
                            $('button', oAppSms).text(message + ' (' + timeout + ')');

                            setTimeout(function() {
                                buttonUpdate(--timeout, message);
                            }, 1000);
                        }
                    };

                    $.ajax({
                        type: 'POST',
                        url: window.c24LpRoot + 'api/?k=24&a=sendsms&q=appsplash',
                        data: oData,
                        dataType: 'json',
                        timeout: 6000,
                    }).done(function(json) {
                        let buttonText = '';
                        if (json.status == 200) {
                            buttonText = $('button', oAppSms).data('send');
                        } else {
                            buttonText = $('button', oAppSms).data('error');
                        }

                        buttonUpdate(5, buttonText);

                    }).fail(function() {
                        const buttonText = $('button', oAppSms).data('error');
                        buttonUpdate(5, buttonText);
                    });
                });
            }
        },

        show: function() {

            if (! $('.c24AppSplash').length) {
                $('body').removeClass('c24Fixed');
                $('body').removeClass('js24AppSplash');
                return;
            }

            $('body').addClass('c24Fixed');
            $('body').addClass('js24AppSplash');
            $('.c24AppSplash').show();
        },

        hide: function() {

            $('.c24AppSplash').hide();
            $('body').removeClass('c24Fixed');
            $('body').removeClass('js24AppSplash');

            c24.lp.appSplash.setHideCookie();
        },

        setHideCookie: function() {

            if (window.c24LpAppSplashCookie) {

                if (window.c24LpAppSplashTimeout > 0) {

                    const cookieDate = new Date(Date.now() + window.c24LpAppSplashTimeout * 1000);
                    document.cookie = window.c24LpAppSplashCookie + '=1;'
                + 'expires=' + cookieDate.toGMTString() + ';'
                + 'domain=' + window.location.hostname + ';'
                + 'path=' + window.c24LpRoot + ';'
                + 'secure;'
                + 'samesite=lax';

                } else {
                    document.cookie = window.c24LpAppSplashCookie + '=1;'
                + 'domain=' + window.location.hostname + ';'
                + 'path=' + window.c24LpRoot + ';'
                + 'secure;'
                + 'samesite=lax';
                }
            }

            if (window.c24LpAppSplashProductApiUrl && window.c24LpAppSplashProductApiType) {

                if (window.c24LpAppSplashProductApiType === 'iframe') {

                    //setTimeout(function(){
                    $('<iframe>', {
                        src: window.c24LpAppSplashProductApiUrl,
                        frameborder: 0,
                        scrolling: 'no',
                    }).css({
                        display: 'none',
                    }).appendTo('body');
                    //}, 2000);

                } else {

                    let httpType = 'GET';

                    if (window.c24LpAppSplashProductApiType === 'ajax-post') {
                        httpType = 'POST';
                    } else if (window.c24LpAppSplashProductApiType === 'ajax-put') {
                        httpType = 'PUT';
                    }

                    $.ajax({
                        type: httpType,
                        dataType: 'json',
                        url: window.c24LpAppSplashProductApiUrl,
                        xhrFields: {
                            withCredentials: true,
                        },
                        contentType: 'application/json; charset=UTF-8',
                        async: true,
                        timeout: 4000,
                        cache: false,
                    });
                }
            }
        },
    };

    $(document).ready(function() {
        window.c24LpFrameJsReady.then(function() {
            c24.lp.appSplash.init();
        });
    });
})();
